export const CErrorReferralsContext = {
    GET_REWARD: 'GET_REWARD'
} as const;